export default __webpack_public_path__ + "static/media/punchIn.866c828b.png";